import { GenerationStatus } from '@showbie-socrative/socrative-utils';
import { z } from 'zod/v4';

export const insightsSchema = z.object({
  type: z.string(),
  topic: z.string(),
  studentIds: z.array(z.string()),
  description: z.string(),
  questionIds: z.array(z.string()),
  index: z.number(),
});

export const activityInsightsSchema = z.object({
  id: z.uuid(),
  activityInstanceId: z.number(),
  insights: z.object({ insights: z.array(insightsSchema) }).nullable(),
  inputSettings: z.object({
    model: z.string(),
    promptVersion: z.string().optional(),
    generationAttempt: z.number().optional(),
    openAiRequestId: z.string().optional(),
    inputTokens: z.number().optional(),
    outputTokens: z.number().optional(),
    responseTimeMs: z.number().optional(),
  }),
  generationStatus: z.enum(GenerationStatus),
  createdDate: z.iso.datetime(),
  updatedDate: z.iso.datetime(),
  deletedDate: z.iso.datetime().nullable(),
});

export type Insights = z.infer<typeof insightsSchema>;
export type ActivityInsights = z.infer<typeof activityInsightsSchema>;
